enum EditRequestSource {
	Default = 'Default',
	Suggest = 'Suggest',
}

export default EditRequestSource;
